module.exports = __webpack_public_path__ + "img/gend1.f3b45fb.png";